import React from 'react';

export default function SortableTable({ children }) {
    // sortable functionality coming soon
    return <table className='table sortable'>{children}</table>;
}
